import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgFxSliderComponent } from './slider.component';
import { NgFxDraggableDirective } from './draggable.directive';
export { NgFxDraggableDirective } from './draggable.directive';
export { NgFxSliderComponent } from './slider.component';
var NgFxSliderModule = (function () {
    function NgFxSliderModule() {
    }
    NgFxSliderModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [NgFxDraggableDirective, NgFxSliderComponent],
                    exports: [NgFxDraggableDirective, NgFxSliderComponent]
                },] },
    ];
    return NgFxSliderModule;
}());
export { NgFxSliderModule };
